export default __webpack_public_path__ + "static/media/icons-project-folder.7daf47ad.svg";